import {gql} from "graphql-tag";
import {basePageableGraphqlField, baseResponseGraphqlField} from "../../../base.graphql";
import {newsCategoryFields} from "../news-category/news-category.graphql";


export const newsArticleFields = `
id
uniqueId
title
content
images
category {
  ${newsCategoryFields}
}
`;


export const CREATE_NEWS_ARTICLE_MUTATION = gql`
mutation CreateNewsArticleMutation($input: NewsArticleInputObject!) {
  createNewsArticleMutation(input: $input) {
    ${baseResponseGraphqlField}
    data {
      ${newsArticleFields}
    }
  }
}
`


export const UPDATE_NEWS_ARTICLE_MUTATION = gql`
mutation UpdateNewsArticleMutation($input: NewsArticleInputObject!) {
  updateNewsArticleMutation(input: $input) {
    ${baseResponseGraphqlField}
    data {
      ${newsArticleFields}
    }
  }
}
`


export const DELETE_NEWS_ARTICLE_MUTATION = gql`
mutation DeleteNewsArticleMutation($uniqueId: String!) {
  deleteNewsArticleMutation(uniqueId: $uniqueId) {
    ${baseResponseGraphqlField}
  }
}
`


export const GET_NEWS_ARTICLES = gql`
query GetNewsArticles($filtering: NewsArticleFilteringInputObject) {
  getNewsArticles(filtering: $filtering) {
    ${baseResponseGraphqlField}
    ${basePageableGraphqlField}
    data {
      ${newsArticleFields}
    }
  }
}
`
